// Small Apple-style controls shared by the builder panels.
import React from 'react';

export const inp = 'w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-[13px] text-slate-900 outline-none transition-colors focus:border-[#15133A] focus:ring-4 focus:ring-[#15133A]/10 placeholder:text-slate-400';

export const Field = ({ label, hint, children, className = '', testId }) => (
  <label className={`block ${className}`} data-testid={testId}>
    <span className="block text-[11px] font-bold text-slate-500 mb-1.5">{label}</span>
    {children}
    {hint && <span className="block mt-1 text-[11px] text-slate-400 leading-relaxed">{hint}</span>}
  </label>
);

export const Toggle = ({ on, onChange, label, sub, testId }) => (
  <button type="button" role="switch" aria-checked={!!on} onClick={() => onChange(!on)} data-testid={testId}
    className="w-full flex items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white px-3.5 py-3 text-left hover:border-slate-300 transition-colors">
    <span className="min-w-0"><span className="block text-[13px] font-bold text-slate-900">{label}</span>{sub && <span className="block text-[11px] text-slate-500 leading-snug">{sub}</span>}</span>
    <span className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${on ? 'bg-[#15133A]' : 'bg-slate-200'}`}><span className={`inline-block h-5 w-5 rounded-full bg-white shadow transition-transform ${on ? 'translate-x-5.5 translate-x-[22px]' : 'translate-x-0.5'}`} /></span>
  </button>
);

export const Segmented = ({ value, onChange, options, size = 'sm', testId }) => (
  <div className={`inline-flex rounded-xl bg-slate-100 p-0.5 ${size === 'lg' ? 'text-sm' : 'text-xs'}`} data-testid={testId}>
    {options.map(([k, l, Icon]) => (
      <button key={k} type="button" onClick={() => onChange(k)} data-testid={testId ? `${testId}-${k}` : undefined}
        className={`inline-flex items-center gap-1.5 rounded-[10px] px-3 py-1.5 font-bold transition-all ${value === k ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-800'}`}>
        {Icon && <Icon className="w-3.5 h-3.5" />}{l}
      </button>
    ))}
  </div>
);

export const PanelTitle = ({ children, right }) => (
  <div className="flex items-center justify-between px-4 pt-4 pb-2"><p className="text-[11px] font-black uppercase tracking-[0.16em] text-slate-400">{children}</p>{right}</div>
);

export const IconBtn = ({ onClick, title, Icon, danger, testId, disabled, className = '' }) => (
  <button type="button" onClick={onClick} title={title} aria-label={title} disabled={disabled} data-testid={testId}
    className={`inline-flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 transition-colors disabled:opacity-30 ${danger ? 'hover:bg-rose-50 hover:text-rose-600' : 'hover:bg-slate-100 hover:text-slate-900'} ${className}`}><Icon className="w-4 h-4" /></button>
);
